import { ArrowDown, Play } from 'lucide-react'
import './LandingHero.css'

interface Props {
  onStart: () => void
}

export function LandingHero({ onStart }: Props) {
  return (
    <section className="landing-hero">
      <div className="hero-inner">

        {/* ── Left: Text ── */}
        <div className="hero-text">
          <div className="hero-eyebrow">Kostenloses PDF &nbsp;·&nbsp; Kein Account nötig</div>
          <h1 className="hero-headline">
            Deine Chats sind mehr als nur Daten.{' '}
            <span className="hero-headline-accent">Sie sind deine Geschichte.</span>
          </h1>
          <p className="hero-subtext">
            WhatsApp-Verläufe als wunderschön gestaltete PDFs — mit Bildern, Emojis und
            Original-Layout. Sicher, privat, für die Ewigkeit.
          </p>
          <div className="hero-actions">
            <button className="hero-cta-primary" onClick={onStart}>
              <ArrowDown size={20} />
              Kostenlos starten
            </button>
            <button
              className="hero-cta-secondary"
              onClick={() =>
                document.getElementById('so-funktioniert')?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              <Play size={18} />
              So funktioniert's
            </button>
          </div>
          <p className="hero-trust-line">
            <span>✓ PDF kostenlos (mit Wasserzeichen)</span>
            <span className="hero-trust-separator">·</span>
            <span>Vollständig für einmalig €4,99</span>
            <span className="hero-trust-separator">·</span>
            <span>Kein Abo</span>
          </p>
        </div>

        {/* ── Right: Animated Phone Mockup ── */}
        <div className="hero-visual" aria-hidden="true">
          <div className="hero-phone-wrap">
            <div className="hero-phone">
              <div className="hero-phone-status">9:41</div>
              <div className="hero-phone-header">
                <div className="hero-phone-avatar">A</div>
                <div>
                  <div className="hero-phone-name">Anna &amp; Max</div>
                  <div className="hero-phone-sub">WhatsApp Chat</div>
                </div>
              </div>
              <div className="hero-phone-chat">
                <div className="hero-bubble right b1">Hey! 👋</div>
                <div className="hero-bubble left  b2">Wie war dein Urlaub? 🌴</div>
                <div className="hero-bubble right b3">Wunderschön! Schau mal 😍</div>
                <div className="hero-bubble right b4 media-bubble">
                  <div className="bubble-media-thumb"></div>
                  <span>IMG_2847.jpg</span>
                </div>
                <div className="hero-bubble left  b5">So schön! 💚 Für immer gespeichert</div>
              </div>
            </div>

            {/* PDF overlay card */}
            <div className="hero-pdf-card">
              <div className="hero-pdf-icon">PDF</div>
              <div className="hero-pdf-lines">
                <div className="hero-pdf-line w-full"></div>
                <div className="hero-pdf-line w-3q"></div>
                <div className="hero-pdf-line w-full"></div>
                <div className="hero-pdf-line w-half"></div>
              </div>
              <div className="hero-pdf-check">✓ Als PDF gespeichert</div>
            </div>
          </div>
        </div>

      </div>
    </section>
  )
}
